module.exports = __webpack_public_path__ + "images/marketing/map-east.jpg";